import React from "react";
import { useField, useFormikContext } from "formik";

import classes from "./FormFieldError.module.scss";

type ErrorMessageProps = {
  name: string;
};

const FormFieldError = ({ name }: ErrorMessageProps) => {
  const [, meta] = useField(name);
  const { submitCount } = useFormikContext();

  const shouldShow = Boolean(meta.error && (meta.touched || submitCount > 0));

  if (!shouldShow) {
    return null;
  }

  return <span className={classes.errorMessage}>{meta.error}</span>;
};

export default FormFieldError;
